module.exports = __webpack_public_path__ + "img/dark-notification.1d3560e5.svg";